import React, { Component } from 'react';

import Datepicker from '../../common/components/datepicker';
import PropTypes from 'prop-types';
import { buildReportDateOptions } from '../../utils/datepicker-utils';
import { changeDates } from '../../common/actions/datepicker-action-creators';
import { connect } from 'react-redux';
import { selectedDateOptionSelector } from '../selectors/reports-selectors';

export class DatepickerContainer extends Component{
    handleDateChange = ( option, start, end ) => {
        this.props.changeDates( {
            end,
            namespace: this.props.namespace,
            option,
            start,
        } );
    };

    render(){
        const { namespace, selectedOption, isDomainPortfolio } = this.props;
        const dateOptions = buildReportDateOptions( isDomainPortfolio );

        return (
            <Datepicker
                automationId={`datepicker-${namespace}`}
                selectedOption={selectedOption}
                handleDateChange={this.handleDateChange}
                dateOptions={dateOptions}
            />
        );
    }
};

/* istanbul ignore next */
const mapStateToProps = state => {
    return {
        selectedOption: selectedDateOptionSelector( state )
    };
};

DatepickerContainer.propTypes = {
    changeDates: PropTypes.func.isRequired,
    isDomainPortfolio: PropTypes.bool.isRequired,
    namespace: PropTypes.string.isRequired,
    selectedOption: PropTypes.string.isRequired,
};

export default connect( mapStateToProps, { changeDates } )( DatepickerContainer );
